import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=4b5a21a7"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5a21a7')) {
      api.createRecord('4b5a21a7', component.options)
    } else {
      api.reload('4b5a21a7', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=4b5a21a7", function () {
      api.rerender('4b5a21a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/ForgotPassword.vue"
export default component.exports